import { createSlice } from "@reduxjs/toolkit";

const initialOfficeState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: {total : 0},
  links: null,
  lastError: null,
  officeForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};


export const officeSlice = createSlice({
  name: "office",
  initialState: initialOfficeState,
  reducers: {
		catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
      
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    finishCall: (state) => {
      state.actionsLoading = false;
    },
		officeFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
		officeAllFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    officeCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.office.push(action.payload.office);
    },
    officeDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.office.filter(el => el.office_id !== action.payload.id);
    },
    getOffice: (state, action) => {
      state.actionsLoading = false;
      state.officeForEdit = action.payload.officeForEdit;
      state.error = null;
    },
    // updateProduct
    officeUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.office = state.entities.office.map(entity => {
        if (entity.office_id === action.payload.office.office_id) {
          return action.payload.office;
        }
        return entity;
      });
    },
  },
});

